import { hydrateRoot } from 'react-dom/client';
import i18n from '../../../i18n/client-i18n';
import './index.global.scss';
import { createArenaSplitPageApp } from './createArenaSplitPageApp';
import { LogoUrlGenerator, ARENA_NAVIGATION_SOURCE } from '@wix/branding-client-lib';
import { biService } from '@wix/branding-logo-client/exports/biService';
import { userAgentDetector, origins } from '@wix/branding-logo-client/exports/clientServices';
import { WixLoginUtils } from '@wix/branding-logo-client/exports/services';
import { loginCustomizedParams } from '@wix/branding-logo-client/exports/constants';

const initialI18n = window.__INITIAL_I18N__;
const experiments = window.__EXPERIMENTS__;
const referralAdditionalInfo = window.__REFERRAL_ADDITIONAL_INFO__;
const loggedInDetails = window.__LOGGED_IN_DETAILS__;
const basename = window.__BASE_PATH__;
const debugApp = window.__DEBUG_APP__;
const companyDetails = window.__COMPANY_DETAILS__;
const location = window.location;
const queryParams = window.__QUERY_PARAMS__;
const i19n = i18n(initialI18n);
const logoUrlGenerator = new LogoUrlGenerator({ protocol: location.protocol, host: location.host, mountPoint: basename, debugApp, experiments });

biService.initSessionId({ screenName: 'arenaSplitPage' });

function sendBi(eventName, params) {
  try {
    biService.biLogSafe(biLog => {
      biLog(eventName, { ...params });
    });
  } catch (error) {
    console.error(`[ArenaOnBoardingController.js:sendBi] error`, error.message);
  }
}

function navigateWindow(url, isNewWindow) {
  if (isNewWindow) {
    window.open(url, '_blank');
  } else {
    window.location.href = url;
  }
}

function goToOnBoarding() {
  sendBi('arenaSplitPageLogoClick', { pageName: 'arenaSplitPage' });
  const { companyName } = companyDetails;

  const additionalParams = { ...queryParams };
  const { origin } = queryParams;
  additionalParams.referralAdditionalInfo = origins.ARENA_SPLIT_PAGE;

  // We add the debugApp queryParams on logoUrlGenerator navigation functions
  delete additionalParams.debugApp;

  const finalParams = Object.entries(additionalParams).map(([key, value]) => {
    return { key, value };
  });
  let onboardingUrl = '';

  const shouldGoToIndustryPage = companyName && !origin === origins.MARKETING_HOME_PAGE;
  if (shouldGoToIndustryPage) {
    onboardingUrl = logoUrlGenerator.getIndustryOnboardingUrl(finalParams);
  } else if (experiments['specs.logo-builder.client.BrandFromAiChatBot'] === 'true') {
    onboardingUrl = logoUrlGenerator.getAIChatBotPageUrl();
  } else {
    onboardingUrl = logoUrlGenerator.getHomePageUrl(finalParams);
  }
  navigateWindow(onboardingUrl, false);
}

function goToLogin() {
  sendBi('splitPageClickLogin', { origin: 'arenaSplitPage' });
  const cancelUrl = window.location.href;
  const returnUrl = 'https://manage.wix.com/logo/maker/esh';
  WixLoginUtils.setCustomizedParam(loginCustomizedParams.LOGO_MAKER_STANDALONE_PARAM);
  const url = WixLoginUtils.getLoginUrl(returnUrl, cancelUrl, initialI18n.locale);
  navigateWindow(url, false);
}

function goToArena() {
  const finalUrl = logoUrlGenerator.getPartnersPageUrl(ARENA_NAVIGATION_SOURCE.SPLIT_PAGE);
  navigateWindow(finalUrl, true);
}

if (userAgentDetector.isReactWebview()) {
  goToOnBoarding();
} else {
  const { isLoggedIn = false } = loggedInDetails || {};
  const app = createArenaSplitPageApp({
    i19n,
    experiments,
    goToOnBoarding,
    goToLogin,
    goToArena,
    sendBi,
    referralAdditionalInfo,
    isLoggedIn
  });

  hydrateRoot(document.getElementById('root'), app);
}
